export default __webpack_public_path__ + "static/media/2.afc68cf5.jpg";